import { ReactNode } from "react";

import { Container, PageContainer } from "./PageLayout.styles";

type IPageLayoutProps = {
  children: ReactNode;
  className?: string;
  extraPadding?: boolean;
  onClick?: () => void;
};

export function PageLayout({
  children,
  className = "",
  extraPadding = false,
  onClick,
}: IPageLayoutProps) {
  return (
    <Container
      className={className}
      extraPadding={extraPadding}
      onClick={onClick}
    >
      <PageContainer className="page-container">{children}</PageContainer>
    </Container>
  );
}
